import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../services/AxiosInstance";

export const fetchSlrmDcbThunk = createAsyncThunk(
  "slrmDcb/fetch",
  async (filters, { rejectWithValue }) => {
    try {
      const params = {
        fy_year: filters?.fy_year || "",
        from_date: filters?.from_date || "",
        to_date: filters?.to_date || "",
        ward_id: filters?.ward_id || "",
        agent_id: filters?.agent_id || "",

        ...(filters?.home_id
          ? {
              home_id: filters.home_id,
            }
          : {}),

        page: Number(filters?.page || 1),
        pageSize: Number(filters?.pageSize || 20),

        // Send sorting only when frontend selected a column.
        ...(filters?.sort_field
          ? {
              sort_field: filters.sort_field,
              sort_direction:
                String(filters?.sort_direction || "").toLowerCase() === "desc"
                  ? "desc"
                  : "asc",
            }
          : {}),

        export: Number(filters?.export) === 1 ? 1 : 0,
      };

      const res = await api.get("/api/reports/slrm-dcb", {
        params,
      });

      if (!res.data?.success) {
        return rejectWithValue(
          res.data?.message || "Failed to load SLRM DCB"
        );
      }

      return res.data;
    } catch (e) {
      return rejectWithValue(
        e.response?.data?.message ||
          e.message ||
          "Failed to load SLRM DCB"
      );
    }
  }
);

const slice = createSlice({
  name: "slrmDcb",

  initialState: {
    rows: [],
    meta: {},
    loading: false,
    error: null,
  },

  reducers: {
    clearSlrmDcb: (state) => {
      state.rows = [];
      state.meta = {};
      state.loading = false;
      state.error = null;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(fetchSlrmDcbThunk.pending, (state, action) => {
      const isExport = Number(action.meta.arg?.export) === 1;

      // Export must not change table loading state.
      if (isExport) return;

      state.loading = true;
      state.error = null;
    });

    builder.addCase(fetchSlrmDcbThunk.fulfilled, (state, action) => {
      const isExport = Number(action.meta.arg?.export) === 1;

      // Export data is returned through unwrap().
      // Do not replace current table rows or pagination metadata.
      if (isExport) return;

      state.loading = false;
      state.rows = action.payload?.data || [];
      state.meta = action.payload?.meta || {};
      state.error = null;
    });

    builder.addCase(fetchSlrmDcbThunk.rejected, (state, action) => {
      const isExport = Number(action.meta.arg?.export) === 1;

      // Export error is handled inside Excel/PDF functions.
      if (isExport) return;

      state.loading = false;
      state.error =
        action.payload ||
        action.error?.message ||
        "Failed to load SLRM DCB";
    });
  },
});

export const { clearSlrmDcb } = slice.actions;

export default slice.reducer;
